module.exports = __webpack_public_path__ + "img/left.8f747c38.png";